import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import loadable from "@loadable/component";
import OnBoardingFormContainer from "../../containers/OnBoardingFormContainer";
const Login = loadable(() => import("../login/Login"));
const EnterMobile = loadable(() => import("../login/EnterMobile"));
const OtpPage = loadable(() => import("../login/OtpPage"));
const OAuth2RedirectHandler = loadable(() =>
  import("../OAuth2RedirectHandler/OAuth2RedirectHandler")
);
const LandingPageForDocumentUpload = loadable(() =>
  import("../landingPages/LandingPageForDocumentUpload")
);
const SocietyApprovalContainer = loadable(() => import("../SocietyApproval"));
const InteriorFloorPlanForm = loadable(() =>
  import("../InteriorFloorPlanUpload")
);
export default function PublicRoutes() {
  return (
    <Switch>
      <Route path="/" exact={true} component={Login} />
      <Route path="/admin-login" exact={true} component={Login} />
      <Route path="/agent-login" exact={true} component={Login} />
      <Route path="/login" component={EnterMobile} />
      <Route path="/otp" component={OtpPage} />
      <Route path="/oauth2/redirect" component={OAuth2RedirectHandler}></Route>
      <Route
        path="/document-collection-form"
        component={LandingPageForDocumentUpload}></Route>
      <Route
        path="/society-payout-approvals/:id"
        exact={true}
        component={SocietyApprovalContainer}
      />
      <Route path="/onboarding-form" component={OnBoardingFormContainer} />
      <Route path="/floor-plan-form" component={InteriorFloorPlanForm} />
      <Route>
        <Redirect to={"/"}></Redirect>
      </Route>
    </Switch>
  );
}
